import ResetPasswordGeneric from '../ResetPasswordGeneric';

export default function ResetPasswordLavoratore() {
    return (
        <ResetPasswordGeneric
            apiEndpoint="/area-lavoratore/reset-password"
            titolo="Username lavoratore"
            loginUrl="/AreaLavoratore/Login"
        />
    );
}
